import { render } from "./CampaignPSSC.vue?vue&type=template&id=5b71040a"
import script from "./CampaignPSSC.vue?vue&type=script&lang=js"
export * from "./CampaignPSSC.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__